/**
 * @generated from packages/telemetry/schema/analytics-events.schema.json
 * by scripts/generate-event-registry.mjs. Do not edit this file directly.
 */

import { FIRST_TOUCH_PROPERTY_MAX_BYTES } from "./first-touch-properties";

export const ANALYTICS_EVENT_CATALOG = {
  "account.created": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "account.created",
    postHog: "user_signed_up",
    parity: true,
    properties: {
      source: { type: "string", maxBytes: 128, optional: true },
      email: { type: "string", maxBytes: 320, optional: true },
      clerk_user_id: { type: "string", maxBytes: 255, optional: true },
      $insert_id: { type: "string", maxBytes: 255, optional: true },
      org_id: { type: "string", maxBytes: 255, optional: true, nullable: true },
      cid: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.cid, optional: true },
      landing_page: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.landing_page, optional: true },
      referrer: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.referrer, optional: true, nullable: true },
      utm_source: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.utm_source, optional: true, nullable: true },
      utm_medium: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.utm_medium, optional: true, nullable: true },
      utm_campaign: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.utm_campaign, optional: true, nullable: true },
      utm_term: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.utm_term, optional: true, nullable: true },
      utm_content: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.utm_content, optional: true, nullable: true },
      first_seen_at: { type: "string", maxBytes: FIRST_TOUCH_PROPERTY_MAX_BYTES.first_seen_at, optional: true },
    },
  },
  "api_key.created": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "api_key.created",
    postHog: "api_key.created",
    properties: {
      key_type: { type: "string", maxBytes: 32, values: ["system", "user", "organization"] },
      source: { type: "string", maxBytes: 32, values: ["settings", "get_started", "cli_auth_exchange"] },
      expiration: { type: "string", maxBytes: 8, optional: true, values: ["1d", "7d", "30d", "90d", "1y"] },
      expiration_seconds: { type: "number", optional: true, nullable: true, integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
    },
  },
  "experiment.created": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "experiment.created",
    postHog: "experiment.created",
    parity: true,
    properties: {
      org_id: { type: "string", maxBytes: 255, optional: true },
      experiment_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "experiment.viewed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "experiment.viewed",
    postHog: "experiment.viewed",
    properties: {
      experiment_id: { type: "string", maxBytes: 255 },
      completed_run_count: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
    },
  },
  "onboarding.step_completed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "onboarding.step_completed",
    postHog: "onboarding.step_completed",
    properties: {
      step_id: { type: "string", maxBytes: 32, values: ["account", "cli-install", "first-experiment"] },
      completion_source: { type: "string", maxBytes: 32, values: ["api_key_used", "cli_credentials_minted", "experiment_created", "experiment_uploaded"] },
    },
  },
  "org.created": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "org.created",
    postHog: "org_created",
    parity: true,
    properties: {
      source: { type: "string", maxBytes: 64, values: ["clerk.organization_created"] },
      clerk_user_id: { type: "string", maxBytes: 255, optional: true },
      clerk_organization_id: { type: "string", maxBytes: 255 },
      organization_name: { type: "string", maxBytes: 255, optional: true },
      $insert_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "org.member.added": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "org.member.added",
    postHog: "org_membership_created",
    parity: true,
    properties: {
      source: { type: "string", maxBytes: 64, values: ["clerk.organization_membership_created"] },
      email: { type: "string", maxBytes: 320, optional: true },
      role: { type: "string", maxBytes: 255 },
      clerk_user_id: { type: "string", maxBytes: 255 },
      clerk_organization_id: { type: "string", maxBytes: 255 },
      organization_name: { type: "string", maxBytes: 255, optional: true },
      clerk_membership_id: { type: "string", maxBytes: 255 },
      $insert_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "org.member.removed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "org.member.removed",
    postHog: "org_membership_removed",
    parity: true,
    properties: {
      source: { type: "string", maxBytes: 64, values: ["clerk.organization_membership_deleted"] },
      email: { type: "string", maxBytes: 320, optional: true },
      role: { type: "string", maxBytes: 255 },
      clerk_user_id: { type: "string", maxBytes: 255 },
      clerk_organization_id: { type: "string", maxBytes: 255 },
      organization_name: { type: "string", maxBytes: 255, optional: true },
      clerk_membership_id: { type: "string", maxBytes: 255 },
      $insert_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "org.invite.created": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "org.invite.created",
    postHog: "org_invitation_created",
    parity: true,
    properties: {
      source: { type: "string", maxBytes: 64, values: ["clerk.organization_invitation_created"] },
      email: { type: "string", maxBytes: 320, optional: true },
      role: { type: "string", maxBytes: 255 },
      clerk_user_id: { type: "string", maxBytes: 255, optional: true },
      clerk_organization_id: { type: "string", maxBytes: 255 },
      organization_name: { type: "string", maxBytes: 255, optional: true },
      clerk_invitation_id: { type: "string", maxBytes: 255 },
      $insert_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "org.invite.accepted": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "org.invite.accepted",
    postHog: "org_invitation_accepted",
    parity: true,
    properties: {
      source: { type: "string", maxBytes: 64, values: ["clerk.organization_invitation_accepted"] },
      email: { type: "string", maxBytes: 320, optional: true },
      role: { type: "string", maxBytes: 255 },
      clerk_user_id: { type: "string", maxBytes: 255, optional: true },
      clerk_organization_id: { type: "string", maxBytes: 255 },
      organization_name: { type: "string", maxBytes: 255, optional: true },
      clerk_invitation_id: { type: "string", maxBytes: 255 },
      $insert_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "run.submitted": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "run.submitted",
    postHog: "run.submitted",
    parity: true,
    properties: {
      org_id: { type: "string", maxBytes: 255, optional: true },
      run_request_id: { type: "string", maxBytes: 255, optional: true },
      experiment_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "run.completed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "run.completed",
    postHog: "run.completed",
    parity: true,
    properties: {
      org_id: { type: "string", maxBytes: 255, optional: true },
      run_id: { type: "string", maxBytes: 255, optional: true },
      run_request_id: { type: "string", maxBytes: 255, optional: true },
      exit_reason: { type: "string", maxBytes: 255, optional: true, nullable: true },
    },
  },
  "run.failed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "run.failed",
    postHog: "run.failed",
    parity: true,
    properties: {
      org_id: { type: "string", maxBytes: 255, optional: true },
      run_id: { type: "string", maxBytes: 255, optional: true },
      run_request_id: { type: "string", maxBytes: 255, optional: true },
      exit_reason: { type: "string", maxBytes: 255, optional: true, nullable: true },
    },
  },
  "billing.credits_purchased": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "billing.credits_purchased",
    postHog: "billing.credits_purchased",
    properties: {
      checkout_session_id: { type: "string", maxBytes: 255 },
      ledger_id: { type: "string", maxBytes: 255 },
      amount_micros: { type: "string", maxBytes: 64 },
      currency: { type: "string", maxBytes: 16 },
      pack_id: { type: "string", maxBytes: 255 },
      stripe_event_id: { type: "string", maxBytes: 255 },
    },
  },
  "billing.credits_reloaded": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "billing.credits_reloaded",
    postHog: "billing.credits_reloaded",
    properties: {
      invoice_id: { type: "string", maxBytes: 255 },
      billing_cycle_id: { type: "string", maxBytes: 255 },
      ledger_id: { type: "string", maxBytes: 255, nullable: true },
      base_ledger_id: { type: "string", maxBytes: 255, nullable: true },
      amount_micros: { type: "string", maxBytes: 64 },
      base_amount_micros: { type: "string", maxBytes: 64 },
      currency: { type: "string", maxBytes: 16 },
    },
  },
  "billing.credit_admission_denied": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "billing.credit_admission_denied",
    postHog: "billing.credit_admission_denied",
    properties: {
      run_request_id: { type: "string", maxBytes: 255 },
      run_count: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
      balance_micros: { type: "number", integer: true, min: Number.MIN_SAFE_INTEGER, max: Number.MAX_SAFE_INTEGER },
      required_balance_micros: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
      rate_micros: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
      effective_mode: { type: "string", maxBytes: 16, values: ["enforce"] },
    },
  },
  "billing.plan_downgraded": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "billing.plan_downgraded",
    postHog: "billing.plan_downgraded",
    properties: {
      stripe_subscription_id: { type: "string", maxBytes: 255 },
      plan_key: { type: "string", maxBytes: 32, values: ["basic"] },
      status: { type: "string", maxBytes: 32 },
      period_start: { type: "string", maxBytes: 64 },
      period_end: { type: "string", maxBytes: 64 },
      stripe_event_id: { type: "string", maxBytes: 255 },
    },
  },
  "billing.plan_upgraded": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "billing.plan_upgraded",
    postHog: "billing.plan_upgraded",
    properties: {
      stripe_subscription_id: { type: "string", maxBytes: 255 },
      plan_key: { type: "string", maxBytes: 32, values: ["pro"] },
      status: { type: "string", maxBytes: 32 },
      period_start: { type: "string", maxBytes: 64 },
      period_end: { type: "string", maxBytes: 64 },
      stripe_event_id: { type: "string", maxBytes: 255 },
    },
  },
  "mcp.tool.completed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "mcp.tool.completed",
    postHog: "mcp.tool.completed",
    properties: {
      tool_name: { type: "string", maxBytes: 255 },
      duration_ms: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
      outcome: { type: "string", maxBytes: 16, values: ["success", "error"] },
    },
  },
  "agent.interaction.completed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "agent.interaction.completed",
    postHog: "agent.interaction.completed",
    properties: {
      agent: { type: "string", maxBytes: 128 },
      channel_kind: { type: "string", maxBytes: 64 },
      outcome: { type: "string", maxBytes: 16, values: ["completed", "failed", "cancelled"] },
      model: { type: "string", maxBytes: 128 },
      session_id: { type: "string", maxBytes: 255 },
      turn_id: { type: "string", maxBytes: 255 },
    },
  },
  "agent.external_action": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "agent.external_action",
    postHog: "agent.external_action",
    properties: {
      agent: { type: "string", maxBytes: 128 },
      provider: { type: "string", maxBytes: 64 },
      target: { type: "string", maxBytes: 512 },
      action: { type: "string", maxBytes: 128 },
      outcome: { type: "string", maxBytes: 16, values: ["accepted", "rejected", "failed"] },
      correlation_id: { type: "string", maxBytes: 255 },
    },
  },
  "agent.google_service_account_fallback": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "agent.google_service_account_fallback",
    postHog: "agent.google_service_account_fallback",
    properties: {
      agent: { type: "string", maxBytes: 128 },
      principal: { type: "string", maxBytes: 255 },
      reason: { type: "string", maxBytes: 32, values: ["oauth_unavailable", "oauth_access_denied"] },
      request_path: { type: "string", maxBytes: 512 },
    },
  },
  "api.request.completed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "api.request.completed",
    postHog: "api.request.completed",
    properties: {
      endpoint: { type: "string", maxBytes: 255 },
      status: { type: "number", integer: true, min: 100, max: 599 },
      duration_ms: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
    },
  },
  axp_query_sql: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_query_sql",
    postHog: "axp_query_sql",
    properties: {
      source: { type: "string", maxBytes: 32, values: ["api", "cli", "cli-retest", "mcp", "public_share"] },
      org_id: { type: "string", maxBytes: 255 },
      run_id: { type: "string", maxBytes: 255, nullable: true },
      experiment_id: { type: "string", maxBytes: 255, nullable: true },
      data_schema: { type: "string", maxBytes: 32, values: ["legacy", "session_data_v1"] },
      sql: { type: "string", maxBytes: 256 * 1024 },
      sql_bytes: { type: "number", integer: true, min: 0, max: 256 * 1024 },
      limit: { type: "number", min: Number.MIN_SAFE_INTEGER, max: Number.MAX_SAFE_INTEGER },
      row_count: { type: "number", integer: true, min: 0, max: 10_000 },
      elapsed_ms: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
      synthetic: { type: "boolean" },
      dry_run: { type: "boolean" },
      capped: { type: "boolean" },
      success: { type: "boolean" },
      error: { type: "string", maxBytes: 256 * 1024, optional: true },
    },
  },
  "query.succeeded": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "query.succeeded",
    postHog: "axp_query_sql",
    properties: {
      source: { type: "string", maxBytes: 32, values: ["api", "cli", "mcp", "public_share"] },
      query_id: { type: "string", maxBytes: 64 },
      duration_ms: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
      outcome: { type: "string", maxBytes: 16, values: ["success"] },
      query_text: { type: "string", maxBytes: 256 * 1024 },
      share_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "query.failed": {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "query.failed",
    postHog: "axp_query_sql",
    properties: {
      source: { type: "string", maxBytes: 32, values: ["api", "cli", "mcp", "public_share"] },
      query_id: { type: "string", maxBytes: 64 },
      duration_ms: { type: "number", integer: true, min: 0, max: Number.MAX_SAFE_INTEGER },
      outcome: { type: "string", maxBytes: 16, values: ["failure"] },
      query_text: { type: "string", maxBytes: 256 * 1024 },
      error_message: { type: "string", maxBytes: 256 * 1024 },
      share_id: { type: "string", maxBytes: 255, optional: true },
    },
  },
  "cli.command.completed": {
    table: "cli_events",
    producerSurface: "cli",
    clickHouse: "cli.command.completed",
    postHog: "ax_cli_command",
    parity: true,
    properties: {
      command: { type: "string", maxBytes: 255 },
      success: { type: "boolean" },
      exit_code: { type: "number", optional: true, integer: true, min: 0, max: 255 },
      duration_ms: { type: "number", integer: true, min: 0, max: 4_294_967_295 },
      cli_version: { type: "string", maxBytes: 64 },
      os: { type: "string", maxBytes: 128 },
    },
  },
  pageleave: {
    table: "web_conversions",
    producerSurface: "web",
    clickHouse: "pageleave",
    postHog: "pageleave",
    properties: {
      pageview_id: { type: "string", maxBytes: 64 },
    },
  },
  element_interaction: {
    table: "web_conversions",
    producerSurface: "web",
    clickHouse: "element_interaction",
    postHog: "element_interaction",
    properties: {
      element: { type: "string", maxBytes: 16, values: ["a", "button", "form", "input", "select", "textarea", "label"] },
      action: { type: "string", maxBytes: 16, values: ["click", "change", "submit"] },
      element_id: { type: "string", maxBytes: 128, optional: true },
      href_path: { type: "string", maxBytes: 255, optional: true },
      input_type: { type: "string", maxBytes: 32, optional: true },
    },
  },
  waitlist_modal_opened: {
    table: "web_conversions",
    producerSurface: "web",
    clickHouse: "waitlist_modal_opened",
    postHog: "waitlist_modal_opened",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  waitlist_form_submitted: {
    table: "web_conversions",
    producerSurface: "web",
    clickHouse: "waitlist_form_submitted",
    postHog: "waitlist_form_submitted",
    properties: {
      email: { type: "string", maxBytes: 320, optional: true },
    },
  },
  signup_cta_clicked: {
    table: "web_conversions",
    producerSurface: "web",
    clickHouse: "signup_cta_clicked",
    postHog: "signup_cta_clicked",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  waitlist_signed_up: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "waitlist_signed_up",
    postHog: "waitlist_signed_up",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  contact_form_submitted: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "contact_form_submitted",
    postHog: "contact_form_submitted",
    properties: {
      email: { type: "string", maxBytes: 320, optional: true },
    },
  },
  contact_meeting_booked: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "contact_meeting_booked",
    postHog: "contact_meeting_booked",
    properties: {
      email: { type: "string", maxBytes: 320, optional: true },
    },
  },
  banner_cta_clicked: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "banner_cta_clicked",
    postHog: "banner_cta_clicked",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  banner_dismissed: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "banner_dismissed",
    postHog: "banner_dismissed",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  command_center_opened: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "command_center_opened",
    postHog: "command_center_opened",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  command_center_command_selected: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "command_center_command_selected",
    postHog: "command_center_command_selected",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_org_auth_recovery: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_org_auth_recovery",
    postHog: "axp_org_auth_recovery",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_org_auth_final_failure: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_org_auth_final_failure",
    postHog: "axp_org_auth_final_failure",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_realtime_channel_status: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_realtime_channel_status",
    postHog: "axp_realtime_channel_status",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_realtime_reconnect_scheduled: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_realtime_reconnect_scheduled",
    postHog: "axp_realtime_reconnect_scheduled",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_realtime_gap_catchup: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_realtime_gap_catchup",
    postHog: "axp_realtime_gap_catchup",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_realtime_transport_disconnected: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_realtime_transport_disconnected",
    postHog: "axp_realtime_transport_disconnected",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_realtime_auth_missing: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_realtime_auth_missing",
    postHog: "axp_realtime_auth_missing",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_realtime_channel_open_failed: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_realtime_channel_open_failed",
    postHog: "axp_realtime_channel_open_failed",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_realtime_payload_apply_failed: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_realtime_payload_apply_failed",
    postHog: "axp_realtime_payload_apply_failed",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_run_secrets_consumed: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_run_secrets_consumed",
    postHog: "axp_run_secrets_consumed",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_trace_analysis_created: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_trace_analysis_created",
    postHog: "axp_trace_analysis_created",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_secret_set: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_secret_set",
    postHog: "axp_secret_set",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
  axp_secret_deleted: {
    table: "platform_events",
    producerSurface: "server",
    clickHouse: "axp_secret_deleted",
    postHog: "axp_secret_deleted",
    properties: {},
    additionalProperties: { maxKeys: 32, maxBytes: 8 * 1024 },
  },
} as const;
